import { Button, TagsInput, Typography } from '@mantine/core';
import { ErrorBoundary } from '@sentry/react';
import { Panel } from 'components/Panel';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { tKeys, useTranslation } from 'locales';
import { useState } from 'react';
import HTML from 'shared/components/HTML/HTML';

import { useUpdateExcludedDaybooks } from '../hooks';

const ExcludedDaybooksInner = () => {
  const { t } = useTranslation();
  const { tp_accounting } = useCompanyConfiguration();
  const { updateExcludedDaybooks, isUpdateExcludedDaybooksLoading } = useUpdateExcludedDaybooks();

  const [daybooks, setDaybooks] = useState<Array<string>>(tp_accounting.excluded_daybooks);
  const isDirty = JSON.stringify(daybooks) !== JSON.stringify(tp_accounting.excluded_daybooks);

  return (
    <Panel
      title={t(tKeys.SETTINGS.INTEGRATIONS.EXCLUDED_DAYBOOKS.TITLE)}
      footer={
        <Button
          disabled={!isDirty}
          onClick={() => updateExcludedDaybooks(daybooks)}
          loading={isUpdateExcludedDaybooksLoading}
        >
          {t(tKeys.SAVE)}
        </Button>
      }
    >
      <Typography fz="sm" color="dimmed" mb="md">
        <HTML html={t(tKeys.SETTINGS.INTEGRATIONS.EXCLUDED_DAYBOOKS.DESCRIPTION)} />
      </Typography>
      <TagsInput
        w={400}
        label={t(tKeys.SETTINGS.INTEGRATIONS.EXCLUDED_DAYBOOKS.LABEL)}
        acceptValueOnBlur
        value={daybooks}
        onChange={setDaybooks}
      />
    </Panel>
  );
};

export const ExcludedDaybooks = () => (
  <ErrorBoundary fallback={<div>Error loading excluded daybooks settings.</div>}>
    <ExcludedDaybooksInner />
  </ErrorBoundary>
);
